import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const HeaderWrapper = styled.div`
  position: relative;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
`;

export const CloseIconWrapper = styled.div`
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  cursor: pointer;
`;

export const hideDefaultHeader = css`
  display: none;
`;
